import React, {useEffect, useRef, useState} from "react";
import DataTable from 'react-data-table-component'
import {Link, useParams} from "react-router-dom";
import axios from "axios";
import {Button, Col, Form, Modal, Row, Spinner, Table} from "react-bootstrap";
import {Trash, Edit, Eye, Tool, ChevronLeft} from 'react-feather';
import {Lang, websetting} from "../../../helpers/websetting";
import Moment from "moment";
import {SystemSetting} from "../../../constants/system";
import {useTranslation} from "react-i18next";

function BillDevice(){
    let {bill_id} = useParams()
    const t = useTranslation()

    const [validated, setValidated] = useState(false);
    const [data, setData] = useState([]);
    const [Devices, setDevices] = useState([]);
    const [Status, setStatus] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingModal, setLoadingModal] = useState(false);

    const [show, setShow] = useState(false);
    const [info, setInfo] = useState(true);
    const [infoData, setInfoData] = useState({});
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(SystemSetting.rowInPage);

    const handleClose = () => {
        setShow(false);
        setValidated(false);
        setInfo(true);
        setLoadingModal(false)
        setInfoData({})
    }

    const handleShow = () => {
        setShow(true);
    }


    const columns = [
        {
            name: t.t("iot.global.BomDeviceStatus"),
            selector: (row : any) => row.statusDesc,
        },{
            name: t.t("iot.global.deviceID"),
            selector: (row : any) => row.billDeviceIdPk,
        },{
            name: t.t("iot.global.BOM"),
            selector: (row : any) => row.billIdFk,
        },{
            name: t.t("iot.global.createdDate"),
            selector: (row : any) => Moment(row.createDate).format(websetting.dateFormat),
        },{
            name: t.t("iot.global.actions"),
            cell : (row : any) => <div><Button variant={"outline-danger"} onClick={()=>del(row.billDeviceIdPk)} className={"rounded-circle"}><Trash size={15} /></Button> <Button onClick={()=>edit(row.billDeviceIdPk)}  variant={"outline-info"} className={"rounded-circle"}><Edit size={15} /></Button> <Button  variant={"dark"}  onClick={()=>showInfo(row.billDeviceIdPk)} className={"rounded-circle"}><Eye  size={15} /></Button></div>,
        }
    ];

    const getDevices = () => {
        axios.get(websetting.apiUrl + 'inventory-service/api/v1/invDevices/?pageNO=0&pageSize=5000',
            {
                method: "get",
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                }
            }
        ).then(async function (response) {
            setDevices(response.data.data);
            setLoading(false);
        }).catch(function (error) {
        });
    }
    const getStatus = () => {
        axios.get(websetting.apiUrl + 'setup-service/api/v1/domainValues/INV_BOM_DEV_STATUS/byDomainCode',
            {
                method: "get",
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                }
            }
        ).then(async function (response) {
            setStatus(response.data.domainValuesList);
            setLoading(false);
        }).catch(function (error) {
        });
    }

    const fetchDta = async (page:any) => {
        setLoading(true);
        const p = page - 1
        axios.get(websetting.apiUrl + 'inventory-service/api/v1/BomDevices/'+bill_id+'/billDevices/?pageNO='+p+'&pageSize='+SystemSetting.rowInPage,
            {
                method: "get",
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                }
            }
        ).then(async function (response) {
            setData(response.data.data);
            setLoading(false);
            getDevices()
            getStatus()
        }).catch(function (error) {

        });
    };
    const handlePageChange = (page :any) => {
        fetchDta(page);
    };
    const handlePerRowsChange = async (newPerPage:any, page:any) => {
        fetchDta(page)
    };
    useEffect(() => {
        fetchDta(1); // fetch page 1 of users
    }, []);

    const handleSubmit = (event: any) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        setValidated(true);
        if (form.checkValidity() === true) {
            event.preventDefault();
            setLoadingModal(true)
            const PKid = event.target.Id.value;
            if(event.target.Id.value > 0){
                axios.put(websetting.apiUrl + 'inventory-service/api/v1/BomDevices/'+event.target.Id.value,
                    {
                        /*"inventoryDeviceIdFk": event.target.Devices.value,*/
                        "status":event.target.Status.value,
                        "serialNumber": event.target.SerialNum.value,
                        billIdFk : bill_id,
                    },
                    {
                        method: "put",
                        headers: {
                            'content-type': 'application/json',
                            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                        }
                    }
                ).then(async function (response) {
                    const index = data.findIndex( (array) => {
                        return parseInt(array["billDeviceIdPk"]) === parseInt(PKid)
                    });

                    let prevState = JSON.parse(JSON.stringify(data));
                    prevState[index].statusDesc = response.data.statusDesc
                    //prevState[index].billDeviceIdPk = response.data.billDeviceIdPk
                    prevState[index].billIdFk = response.data.billIdFk
                    prevState[index].createDate = response.data.createDate

                    setData(prevState)
                    setShow(false)
                    setLoadingModal(true)
                }).catch(function (error) {
                    setLoadingModal(true)
                });
            }else {
                axios.post(websetting.apiUrl + 'inventory-service/api/v1/BomDevices/',
                    {
                        "inventoryDeviceIdFk": event.target.Devices.value,
                        "serialNumber": event.target.SerialNum.value,
                        billIdFk : bill_id,
                    },
                    {
                        method: "post",
                        headers: {
                            'content-type': 'application/json',
                            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                        }
                    }
                ).then(async function (response) {
                    setData(data.concat(response.data))
                    setShow(false)
                    setLoadingModal(true)
                }).catch(function (error) {
                    setLoadingModal(true)
                });

            }
        }
    };

    const del = (id:any) => {
        if(window.confirm('Are you sure you wish to delete this item?')) {
            axios.delete(websetting.apiUrl + 'inventory-service/api/v1/BomDevices/' + id,
                {
                    method: "delete",
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                    }
                }
            ).then(async function (response) {
                const newData = data.filter((array) => {
                    return array["billDeviceIdPk"] !== id
                });
                setData(newData)
            }).catch(function (error) {
            });
        }
    }

    const edit = (id:any) => {
        setShow(true);
        if(id > 0){
            setLoadingModal(true)

            axios.get(websetting.apiUrl + 'inventory-service/api/v1/BomDevices/'+id,
                {
                    method: "get",
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                    }
                }
            ).then(async function (response) {
                setLoadingModal(false)
                setInfoData(response.data)
            }).catch(function (error) {
            });
        }
    }

    const showInfo = (id:any) => {
        setShow(true);
        setInfo(false);
        if(id > 0){
            setLoadingModal(true)
            axios.get(websetting.apiUrl + 'inventory-service/api/v1/BomDevices/'+id,
                {
                    method: "get",
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                    }
                }
            ).then(async function (response) {
                setLoadingModal(false)
                setInfoData(response.data)
            }).catch(function (error) {
            });
        }
    }





    const infos =  JSON.parse(JSON.stringify(infoData))

    return(
        <div className={""}>
            <div className="content">
                <div className={"box"}>
                    <div className="pagetitle text-uppercase">
                        <div className={"d-flex justify-content-between"}>
                            <div className={"d-inline-flex"}>
                                <Tool className={"feather"} size={21} />
                                {t.t("iot.global.BomDevices")}
                            </div>
                            <div className={"d-inline-flex align-content-end"}>
                                <Button className={"mx-5"}  variant={"warning"}  onClick={()=>edit(0)}>+ {t.t("iot.global.newDevice")}</Button>
                                <Link className={"mt-2"} to={"../assetsManagement"} >{t.t("iot.global.back")} <ChevronLeft className={" feather feather-chevron-left"} /></Link>
                            </div>
                        </div>

                    </div>
                    <DataTable progressPending={loading}
                               pagination
                               paginationServer
                               paginationTotalRows={totalRows}
                               progressComponent ={<Spinner className={"my-5"} animation={"border"} variant={"warning"} title={"Please Wait"} />}
                               onChangeRowsPerPage={handlePerRowsChange}
                               onChangePage={handlePageChange} columns={columns} data={data} />

                </div>
            </div>

            <Modal size={"lg"} centered={true}
                   show={show}
                   onExited={handleClose}
                   onHide={handleClose}
                   backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title><Tool className={"feather"} /> {t.t("iot.global.BomDevices")}</Modal.Title>
                </Modal.Header>
                <Form noValidate validated={validated}  onSubmit={handleSubmit}>
                    <Modal.Body>
                        {info ?
                            <div>{
                                loadingModal ? <div className={"text-center my-3"}><Spinner animation={"border"} variant={"danger"} /></div> :

                                    <Row>
                                        <Form.Group hidden controlId="Id" >
                                            <Form.Control type={"hidden"}   value={infos.billDeviceIdPk}  />
                                        </Form.Group>
                                        {!infos.billDeviceIdPk &&
                                        <Col md={6}>
                                            <Form.Group className="my-2" controlId="Devices">
                                                <Form.Label>{t.t("iot.global.deviceID")}:</Form.Label>
                                                {Devices &&
                                                <Form.Select defaultValue={infos.inventoryDeviceIdFk} required
                                                             aria-label={t.t("iot.global.deviceID")}
                                                             aria-describedby="msgInput1">
                                                    {Object.keys(Devices).map((titles, i) => {
                                                        return (
                                                            <option
                                                                selected={infos.inventoryDeviceIdFk == JSON.parse(JSON.stringify(Devices[i])).inventoryDeviceIdPk ? true : false}
                                                                value={JSON.parse(JSON.stringify(Devices[i])).inventoryDeviceIdPk}>{JSON.parse(JSON.stringify(Devices[i])).serialNumber}</option>
                                                        );
                                                    })}
                                                </Form.Select>
                                                }
                                                <Form.Control.Feedback type="invalid" id="msgInput1">
                                                    Required Field
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        }

                                        {infos.billDeviceIdPk &&
                                        <Col md={6}>
                                            <Form.Group className="my-2" controlId="Status">
                                                <Form.Label>{t.t("iot.global.status")}:</Form.Label>
                                                {Devices &&
                                                <Form.Select  required
                                                             aria-label={t.t("iot.global.status")}
                                                             aria-describedby="msgInput10">
                                                    {Object.keys(Status).map((titles, i) => {
                                                        return (
                                                            <option
                                                                selected={infos.status == JSON.parse(JSON.stringify(Status[i])).value ? true : false}
                                                                value={JSON.parse(JSON.stringify(Status[i])).value}>{JSON.parse(JSON.stringify(Status[i])).name}</option>
                                                        );
                                                    })}
                                                </Form.Select>
                                                }
                                                <Form.Control.Feedback type="invalid" id="msgInput1">
                                                    Required Field
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        }

                                        <Col md={6}>
                                            <Form.Group className="my-2" controlId="SerialNum" >
                                                <Form.Label>{t.t("iot.global.serialNumber")}:</Form.Label>
                                                <Form.Control type={"text"} required aria-label={t.t("iot.global.BomDevices")} defaultValue={infos.serialNumber} aria-describedby="msgInput5"/>
                                                <Form.Control.Feedback type="invalid"  id="msgInput5" >
                                                    Required Field
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>

                                    </Row>
                            }
                            </div>
                            :
                            <div>
                                {
                                    loadingModal ? <div className={"text-center my-5"}><Spinner animation={"border"} variant={"danger"} /></div> :
                                        <div>
                                            <Table     hover>
                                                <tbody>
                                                <tr><td>ID</td><td>{infos.billDeviceIdPk}</td></tr>
                                                <tr><td>{t.t("iot.global.deviceID")}</td><td>{infos.inventoryDeviceIdFk}</td></tr>
                                                <tr><td>{t.t("iot.global.billID")}</td><td>{infos.billIdFk}</td></tr>
                                                <tr><td>{t.t("iot.global.serialNumber")}</td><td>{infos.serialNumber}</td></tr>
                                                <tr><td>{t.t("iot.global.status")}</td><td>{infos.statusDesc}</td></tr>
                                                <tr><td>{t.t("iot.global.createdBy")}</td><td>{infos.createdBy}</td></tr>
                                                <tr><td>{t.t("iot.global.createdDate")}</td><td>{infos.createDate}</td></tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                }
                            </div>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-dark" onClick={handleClose}>{t.t("iot.global.close")}</Button>
                        {info &&  <Button type={"submit"}  variant="warning">{t.t("iot.global.save")}</Button>}

                    </Modal.Footer>
                </Form>
            </Modal>

        </div>
    )
}
export default BillDevice;
